module.exports = "/static/assets/d96fb43b5556759fae6433eecb5215cd.png";